module.exports = __webpack_public_path__ + "img/item-2(1920).1c82b682.jpg";